import { render } from "./TaskCard.vue?vue&type=template&id=53eca36a&scoped=true&ts=true"
import script from "./TaskCard.vue?vue&type=script&lang=ts"
export * from "./TaskCard.vue?vue&type=script&lang=ts"

import "./TaskCard.vue?vue&type=style&index=0&id=53eca36a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53eca36a"]])

export default __exports__